// extracted by mini-css-extract-plugin
export var numpadContainer = "_mc-1";
export var phoneButton = "_mc-0";